export default {
  confirm(data={}) {
    const obj = $.extend( data, {
      actionType: appConstants.ActionTypes.CONFIRM_ACTION
    });

    MakeShiftEmployeeDispatcher.dispatch(obj);
  },
};